<template>
  <div class="gaizhang-box">
    <!-- <el-header class="page-header__wrap">
      <div class="title">
        {{ $route.matched[0].meta.title }}
        <span v-if="$route.matched[0].meta.title"> > </span>
        {{ $route.meta.title }}
        <span>></span>
        盖章
      </div>
    </el-header> -->
    <div class="top-row">
      <!-- <div>
        <el-switch
          v-model="signType"
          active-text="骑缝章"
          inactive-text="普通章"
          :active-value="2"
          :inactive-value="1"
          @change="changesignType"
          style="margin-right: 20px"
        >
        </el-switch>
        <el-switch
          v-show="signType == 2"
          v-model="printType"
          active-text="双面打印"
          inactive-text="单面打印"
          :active-value="2"
          :inactive-value="1"
        >
        </el-switch>
      </div> -->
      <div>
        <el-button size="mini" type="primary" :disabled="submitLoading" :loading="submitLoading" @click="submit">提交</el-button>
        <el-button size="mini" @click="cancel">取消</el-button>
      </div>
    </div>

    <div class="page-main__wrap">
      <!-- <div class="action-row">
        <div>
          <el-upload
            class="upload-demo"
            action="/api/common/qiniu/uploadFile"
            :limit="1"
            :headers="{ token: token }"
            list-type="text"
            :on-preview="
              (file) => {
                handlePictureCardPreview(file);
              }
            "
            :on-success="handleAvatarSuccess"
            :on-remove="deleteImg"
            :on-exceed="handleExceed"
            :file-list="img_value"
            accept=".pdf"
          >
            <el-button
              size="small"
              icon="el-icon-upload2
"
              >上传pdf文件</el-button
            >
          </el-upload>
          <el-button
            size="mini"
            style="height: 32px; margin-left: 10px"
            @click="addSignatureUser"
            icon="el-icon-upload2
"
            >上传印章</el-button
          >
          <el-button
            size="mini"
            style="height: 32px; margin-left: 10px"
            @click="getSignature"
            icon="el-icon-upload2
"
            >下载</el-button
          >
          <el-button
            type="danger"
            size="mini"
            style="height: 32px; margin-left: 10px"
            icon="el-icon-delete"
            @click="removeSignature"
            >删除签章</el-button
          >
        </div>
        <div>
          <el-button size="small" type="primary" plain @click="back"
            ><i class="back-img"></i>返回</el-button
          >
        </div>
      </div> -->
      <div class="page-main__wrap-main">
        <div class="elesign" style="margin-right: 6px">
          <!-- pdf的预览 -->
          <pdf-preview
            v-if="showpreview"
            ref="preview"
            :pdfUrl="url"
            @renderPdf="renderPdf"
            @pageChange="pageChange"
            :page="page"
          ></pdf-preview>
          <!-- <draggable
            v-model="droppedImages"
            :group="{ name: 'imageGroup', pull: false, put: false }"
          > -->
          <div
            class="canvas-container"
            @dragover.prevent
            @drop.prevent="logPositionData"
          >
            <canvas
              ref="canvasRef"
              id="ele-canvas"
              :class="{ 'has-border': url }"
            ></canvas>
          </div>
          <!-- </draggable> -->
        </div>
        <div class="right-box">
          <div style="color: #d7a428">第一步:请先选择用印文件</div>
          <div>流程附件:</div>
          <div
            class="link-item"
            @click="handleFileClick(item)"
            v-for="(item, index) in flowFileList"
            :key="index + 'sign'"
          >
            {{ item.name }}
          </div>
          <div style="color: #d7a428">第二步:请先选择单位名称</div>
          <div>印章所属单位:</div>
          <div class="custom-radio-group">
            <div
              v-for="(item, index) in signCompany"
              :key="index"
              class="radio-item"
              :class="{ active: activeCompany === item.id }"
              @click="companySelect(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div style="color: #d7a428">第三步:请拖动印章至盖章位置</div>
          <div class="pic-box" v-if="activeCompany">
          <div class="pic-box-img-box">
            <div
              style="margin-bottom: 10px"
              :key="index"
              @dragstart="handleDragStart(item, $event)"
              draggable="true"
              v-for="(item, index) in currentListOnlySign"
            >
              <template v-if="showSignet(item)">
                <img
                  :src="item.img"
                  alt=""
                  @contextmenu.prevent="handleRightClick"
                />
                <div style="text-align: center">{{ item.name }}</div>
              </template>
            </div>
            <div v-for="(item,index) in notUpload" :key="index+'a'">
              <img src="" alt="" />
              <div style="text-align: center">{{ item.name }}</div>
            </div>
        </div>
        </div>
          <div style="color: #d7a428">第四步:请核对已盖章文件无误再提交</div>
          <div>已盖章文件:</div>
          <div
            class="link-item"
            @click="handleFileClick2(item)"
            v-for="(item, index) in signEdPdfName"
            :key="index + 'signed'"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="bottom-row">
        <el-button
          size="mini"
          style="height: 32px; margin-left: 10px"
          @click="getSignature"
          icon="el-icon-download"
          >保存文件</el-button
        >
        <el-button
          type="danger"
          size="mini"
          style="height: 32px; margin-left: 10px"
          icon="el-icon-delete"
          @click="removeSignature"
          >删除签章</el-button
        >
      </div>
    </div>
    <el-dialog
      title=""
      width="400px"
      append-to-body
      custom-class="has-header-dialog" 
      :visible.sync="dialogVisible"
      :modal="false"
      :before-close="reset"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >  
      <template #title>
      <div class="el-dialog-title">骑缝章需确认文件打印方式</div>
    </template>
      <el-form label-width="80px" ref="elFormDom" :model="form.data"
      :rules="form.rules" hide-required-asterisk>
        <el-form-item label="打印方式" prop="printType">
          <el-select v-model="form.data.printType" placeholder="请选择" style="width:180px">
            <el-option label="单面打印" :value="1"></el-option>
            <el-option label="双面打印" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
      <el-row type="flex" justify="end">
        <el-button
          type="primary"
          @click="submitForm"
          >完成</el-button
        >
      </el-row>
    </template>
    </el-dialog>
  </div>
</template>
 
<script>
let pdfjsLib = window["pdfjs-dist/build/pdf"];
pdfjsLib.GlobalWorkerOptions.workerSrc = `/static/build/pdf.worker.js`;
import { getStorage } from "@/storage";
import { fabric } from "fabric";
import pdfPreview from "./components/PdfPreview.vue";
import stampImg from "@/assets/img/default.png";
// import draggable from "vuedraggable";
import { generateUUID, debounce } from "@/util/util.js";
export default {
  name: "PdfStamp",
  components: { pdfPreview },
  props: {
    flowFileList: Array,
    signCompany: Array,
    signet: Array,
    dataInfo: Object,
  },
  data() {
    return {
      dialogVisible: false,
      submitLoading:false,
      showGz: false,
      token: getStorage("token"),
      url: "",
      page: 0,
      seal: "",
      sign: "",
      name: "",
      ht_path_up: "",
      img_value: [],
      canvas: null,
      whDatas: null,
      showpreview: false,

      seal_top: "",
      seal_let: "",
      droppedImages: [], //存储拖拽的图片信息
      signEdImages: {}, //存储已签章的图片信息,键名uuid(uuid代表pdf的id) 键值是一个list数组
      signEdPdfName: [], //已经保存过签章的pdf
      pageNum: "",
      imgUrl:
        "https://qn.cdn.jszhr.com/oa/20250722/b05df17025fc7df0a0b39afce0f5aed4.jpeg",
      sealOfTheList: [
        {
          id: 1,
          name: "壹号农业",
          img: "https://qn.cdn.jszhr.com/oa/20250723/2b36aa8dc1ba848e49b2237acd5e9ac0.png",
        },
        {
          id: 2,
          name: "画压印",
          img: "https://qn.cdn.jszhr.com/oa/20250722/6fb0b5e7edb758e648a96f9a8b38ee18.jpeg",
        },
        {
          id: 3,
          name: "印",
          img: "https://qn.cdn.jszhr.com/oa/20250723/0933cf36f9fe41ab030d6f4336538cce.png",
        },
      ],
      activeCompany: "",
      sealAll: [], //所有公司的印章
      currentSignObj: null, //当前公司下的印章
      currentListOnlySign: [], //当前公司下的印章 只显示签章
      signType: 1, // 普通章1 骑缝章2
      printType: 1, // 打印类型 1单面 2双面
      form:{
        data:{
          printType:'',
        },
        rules:{
          printType:[
            { required: true, message: '请选择打印方式', trigger: 'blur' },
          ],
        },
      },
      //拖入的骑缝章的临时数据
      currentEvt:'',
      currnetItem:'',
      notUpload:[], // 未上传的章

    };
  },
  mounted() {
    this.getCompanySealAll();
    this.debouncedHandleStampMove = debounce(
      this._handleStampMove.bind(this),
      100
    );
  },
  methods: {
    submitForm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.addSignatureUser(this.currnetItem, this.currentEvt);
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    reset() {
      this.form.data.printType = '';
      this.dialogVisible = false;
      this.currentEvt = '';
      this.currnetItem = '';
    },
    handleRightClick(e) {
      if (e.target.tagName === "IMG") {
        e.preventDefault(); // 仅阻止图片右键
      }
    },
    showSignet(item) {
      let idList = this.signet.map((i) => i.id);
      return idList.includes(item.id);
    },
    companySelect(item) {
      this.activeCompany = item.id;
      this.currentSignObj = this.sealAll.find((i) => i.id === item.id);
      if (
        this.currentSignObj &&
        this.currentSignObj.signet_json &&
        this.currentSignObj.signet_json.length > 0
      ) {
        this.currentListOnlySign = this.currentSignObj.signet_json.map(
          (item) => {
            return {
              ...item,
              img: item.link,
            };
          }
        );
        let heTongSign = this.currentListOnlySign.find(item =>item.name == '合同章' || item.name == '合同专用章');
        if(heTongSign) {
          this.currentListOnlySign.push({
            ...heTongSign,
            name: '骑缝章'
          })
        } else {
          
        }
        console.log(this.currentListOnlySign, "this.currentListOnlySign");
        console.log(this.signet, "this.signet");
        this.notUpload = [];
        this.signet.forEach(item =>{
          let obj = this.currentListOnlySign.find(i => i.id == item.id)
          if(!obj) {this.notUpload.push(item)}
        })
      } else {
        this.currentListOnlySign = [];
      }
      // console.log(this.currentListOnlySign, "this.currentListOnlySign");
    },
    //拿所有公司的印章
    getCompanySealAll() {
      this.$http.get("/admin/company/allSignet", { params: {} }).then((res) => {
        if (res.code === 1) {
          this.sealAll = res.data;
          console.log(this.sealAll, "this.sealAll");
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    toogle(val) {
      this.showGz = val;
    },
    back() {
      this.toogle(false);
    },
    handlePictureCardPreview(file) {
      this.url = !!file.url ? file.url : file.response.data.path[0];
    },
    handleAvatarSuccess(event, file, fileList) {
      if (event.code == 1) {
        this.ht_path_up = event.data.all_path_url;
        this.name = file.name;
        this.centerDialogVisible = true;
        this.url = this.ht_path_up;
        this.page = 1;
        this.seal_let = "";
        this.seal_top = "";
        this.sign_let = "";
        this.sign_top = "";
        console.log(this.url, "url");
        this.showpreview = true;
      } else {
        this.$message.error(event.msg);
      }
    },
    deleteImg(file, fileList) {
      this.img_value = [];
      this.ht_path_up = "";
      this.page = "";
      this.seal = "";
      this.sign = "";
    },
    handleExceed(files, fileList) {
      this.$message.warning(`已存在合同文件，请删除后再上传`);
    },
    // 设置绘图区域宽高
    renderPdf(data) {
      // let ll = this.canvas.getObjects();

      this.whDatas = data;
      document.querySelector(".elesign").style.width = data.width + "px";
    },
    // 生成绘图区域
    renderFabric() {
      console.log("renderFabric");
      console.log(this.droppedImages, "回显droppedImages");
      let canvaEle = document.querySelector("#ele-canvas");
      canvaEle.width = this.whDatas.width;
      canvaEle.height = this.whDatas.height;
      console.log(this.whDatas.width, "this.whDatas.width;");
      console.log(this.whDatas.height, "this.whDatas.height;");
      if (this.canvas) {
        this.canvas.dispose(); // 销毁旧Canvas
      }
      this.canvas = new fabric.Canvas(canvaEle);
      this.canvas.getObjects().forEach((obj) => this.canvas.remove(obj));

      let currentSign = this.droppedImages.filter(
        (item) => item.pageNum == this.$refs.preview.pageNum
      );
      if (currentSign.length > 0) {
        currentSign.forEach((item) => {
          this.copySignatureUser(item.left, item.top, item);
        });
      }
      // let container = document.querySelector(".canvas-container");
      // // container.style.position = "absolute";
      //  container.style.width = '100%';
      // container.style.top = "2.625rem";
      // container.style.right = "1%";
      // container.style["padding-bottom"] = "20px";
      // console.log(this.canvas);
    },
    canvasEvents() {
      this.canvas.on("object:moving", (e) => {
        const obj = e.target;
        // 获取缩放后实际尺寸
        const actualWidth = obj.width * obj.scaleX;
        const actualHeight = obj.height * obj.scaleY;
        // 更新坐标计算
        obj.setCoords();
        const bound = obj.getBoundingRect();

        // 左/上边界检测
        if (bound.top < 0 || bound.left < 0) {
          let top_ = Math.max(obj.top, obj.top - bound.top);
          let left_ = Math.max(obj.left, obj.left - bound.left);
          obj.top = top_;
          obj.left = left_;
        }

        // 右/下边界检测
        if (
          bound.top + actualHeight > this.canvas.height ||
          bound.left + actualWidth > this.canvas.width
        ) {
          let top_ = Math.min(
            obj.top,
            this.canvas.height - actualHeight - (bound.top - obj.top)
          );
          let left_ = Math.min(
            obj.left,
            this.canvas.width - actualWidth - (bound.left - obj.left)
          );
          obj.top = top_;
          obj.left = left_;
        }
      });
    },

    // 添加用户签章
    // addSignatureUser(x, y, item)
    addSignatureUser(item, evt) {
      // 正确插入图片的完整解决方案
      fabric.Image.fromURL(
        item.img || item.imgUrl,
        (img) => {
          // 1. 验证图片是否加载成功
          if (!img) {
            console.error("图片加载失败");
            return;
          }
          console.log(img, "图片");
          // 计算缩放比例（保持原图比例）
          // const scaleX = 200 / img.width;
          // const scaleY = 200 / img.height;
          // const scale = Math.min(scaleX, scaleY);
          //方法2
          function getx_y(c) {
            return c/10*(72 / 2.54)
          }
          // const sealSizeInPoints = 4.2 * (72 / 2.54); // 约为119.06点
          // const sealSizeInPixels = sealSizeInPoints * 1; // 在canvas上的像素大小
          const cX = getx_y(item.width);
          const cY = getx_y(item.height);
          //这里根据pdf的坐标来
          const canvas = this.$refs.canvasRef;
          const rect = canvas.getBoundingClientRect();
          // const x = evt.clientX - rect.left - img.width / 2;
          // const y = evt.clientY - rect.top - img.height / 2;
          const x = evt.clientX - rect.left - cX/2;
          const y = evt.clientY - rect.top - cY/2;
          //这里根据pdf的坐标来
          let imgSet = {
            left: x,
            top: y,
            // scaleX: 1,
            // scaleY: 1,
            scaleX: cX / img.width, // 根据图片原始宽度调整
            scaleY: cY / img.height,
            imgUrl: item.img || item.imgUrl,
            // width: item.width,
            // height: item.height,
            lockScalingX: true,
            lockScalingY: true,
            selectable: true, // 关键：启用选择
            evented: true, // 关键：启用交互
            type: 2,
            pageNum: this.$refs.preview.pageNum,
            id: item.id,
            item: {...item,cX:cX,cY:cY},
            signType: item.name=='骑缝章'?2:1,
            printType: item.name=='骑缝章'?this.form.data.printType:1,
            uuid: generateUUID(),
          };
          console.error(imgSet.left/2.8,'xxxxxxxxxxxxxxxx')
          console.error(imgSet.top/2.8,'yyyyyyyyyyyyyyy')
          // img.scaleToWidth(100)
          img.set(imgSet);
          this.droppedImages.push(imgSet); // 存储已添加的图片，以便后续操作
          // 添加移动监听
          img.on("moving", this.handleStampMove);
          // 3. 可添加文字
          // const text = new fabric.Text("江西壹号农业", {
          //   left: img.left + 0, // 相对图片的X偏移
          //   top: img.top + 34, // 相对图片的Y偏移
          //   fontSize: 16,
          //   fill: "#595959", // 白色文字
          //   shadow: "rgba(0,0,0,0.3) 2px 2px 3px", // 文字阴影增强可读性
          //   selectable: false, // 文字不可单独选中
          // });
          // const group = new fabric.Group([img, text], {
          //   subTargetCheck: true, // 允许选中组内元素
          //   originX: "center",
          //   originY: "center",
          //   selectable: true, // 关键：启用选择
          //   evented: true, // 关键：启用交互
          // });
          // this.canvas.add(group);
          this.canvas.add(img);
          this.canvas.renderAll(); // 确保立即渲染
          console.log("图片已添加", img); // 调试输出
          console.log(this.droppedImages,'this.droppedImages')
          this.reset();
        },
        {
          crossOrigin: "anonymous", // 4. 处理跨域问题
        }
      );
    },
    copySignatureUser(x, y, item) {
      // 正确插入图片的完整解决方案
      fabric.Image.fromURL(
        item.imgUrl,
        (img) => {
          // 1. 验证图片是否加载成功
          if (!img) {
            console.error("图片加载失败");
            return;
          }
          // 计算缩放比例（保持原图比例）
          // const scaleX = 100 / img.width;
          // const scaleY = 100 / img.height;
          // const scale = Math.min(scaleX, scaleY);
          let imgSet = {
            left: x,
            top: y,
            scaleX: item.scaleX,
            scaleY: item.scaleY,
            imgUrl: item.imgUrl,
            // width: 100,
            // height: 100,
            lockScalingX: true,
            lockScalingY: true,
            selectable: true, // 关键：启用选择
            evented: true, // 关键：启用交互
            type: item.type,
            pageNum: item.pageNum,
            id: item.id,
            item: item,
            signType: item.signType,
            printType: item.printType,
            uuid: item.uuid,
          };
          img.set(imgSet).on("moving", this.handleStampMove);
          // this.droppedImages.push(imgSet); // 存储已添加的图片，以便后续操作
          // 添加移动监听
          // img.on("moving", this.handleStampMove);
          // 3. 添加到画布并刷新
          this.canvas.add(img);
          this.canvas.renderAll(); // 确保立即渲染
          console.log("图片已添加", img); // 调试输出
        },
        {
          crossOrigin: "anonymous", // 4. 处理跨域问题
        }
      );
      console.log(this.canvas.getObjects(), "copy之后的页数据");
    },
    handleStampMove(evt) {
      this.debouncedHandleStampMove(evt);
    },
    _handleStampMove(evt) {
      console.log(evt, "evt移动");
      const { transform } = evt;
      const { target } = transform;
      //
      const {e} = evt;
      const {clientX,clientY} = e;
      //
      console.log(target, "targettarget");
      // 点对点处理
      let { uuid, top, left,width,height } = target;
      let index = this.droppedImages.findIndex(
        (item) =>
          item.uuid == uuid && item.pageNum == this.$refs.preview.pageNum
      );
      if (index != -1) {
        // const canvas = this.$refs.canvasRef;
        // const rect = canvas.getBoundingClientRect();
        // const x = clientX - rect.left - width / 2;
        // const y = clientY - rect.top - height / 2;
        // this.droppedImages[index].left = x;
        // this.droppedImages[index].top = y;
        this.droppedImages[index].left = target.left;
        this.droppedImages[index].top = target.top;
        console.error(target.left/2.8,'xxxxxxxxxxxxxxxx')
        console.error(target.top/2.8,'yyyyyyyyyyyyyyy')
      }
      console.log(this.droppedImages, "droppedImages00000000000");
    },
    getSignature() {
      console.log(this.droppedImages, "保存的印章数据");
      let ll2 = this.canvas.getObjects();
      console.log(ll2, "lllll");
      console.log(this.flowFileList, "flowFileList");
      if (this.droppedImages.length > 0) {
        let obj = this.flowFileList.find((item) => item.url == this.url);
        if (!obj) {
          return;
        }
        if (this.signEdImages.hasOwnProperty(obj.pdfId)) {
          this.signEdImages[obj.pdfId] = this.droppedImages;
        } else {
          this.signEdImages[obj.pdfId] = this.droppedImages;
        }
        if (!this.signEdPdfName.find((item) => item.pdfId == obj.pdfId)) {
          this.signEdPdfName.push(obj);
        }
      } else {
        this.$message.warning("请先盖章!");
      }
      this.$message.success("保存成功");
      console.log(this.signEdImages, "signEdImages");
      return;
      let ll = this.canvas.getObjects();
      console.log(ll, "lllll");
      if (
        !this.canvas.getObjects().some((item) => {
          return item.type == "2";
        })
      ) {
        return this.$message.warning("请添加印章！");
      }
      let data;
      console.log(this.canvas.getObjects());
      this.canvas.getObjects().forEach((v, i) => {
        if (v.type == 2) {
          data = this.canvas.getObjects()[i];
        }
      });
      console.log(data, "datadatadata");
      this.signaData = {
        width: data.width,
        height: data.height,
        top: data.top,
        left: data.left,
        coordinate_x: Math.round(data.left / 2.8),
        coordinate_y: Math.round(data.top / 2.8),
        pageNum: this.$refs.preview.pageNum,
      };
      this.page = this.$refs.preview.pageNum;
      this.seal = `${this.signaData.coordinate_x}|${this.signaData.coordinate_y}`;
      console.log(this.signaData, "signaData");
    },

    // 删除签章
    removeSignature() {
      console.log(this.canvas.getObjects(), "11");
      let obj = this.canvas.getObjects().pop();
      this.canvas.remove(this.canvas.getObjects().pop());
      let index = this.droppedImages.findIndex((item) => item.uuid == obj.uuid);
      this.droppedImages.splice(index, 1);
      console.log(this.canvas.getObjects(), "22");
      console.log(this.droppedImages, "droppedImages");
    },
    logSourceChange(e) {
      // console.log("源列表拖拽结束：", e);
      // console.log(e.item, "e.item");
    },
    handleDragStart(item, event) {
      console.log(event, "event");
      let companyObj = this.signCompany.find(
        (item) => item.id == this.activeCompany
      );
      const item_ = {
        ...item,
        companyObj: companyObj,
      };
      event.dataTransfer.setData("text/plain", JSON.stringify(item_));
      console.log("开始拖拽");
    },

    logPositionData(evt) {
      const item = JSON.parse(evt.dataTransfer.getData("text/plain"));
      console.log(item, "item");
      evt.preventDefault();
      if(item.name == '骑缝章'){
        this.dialogVisible = true;
        this.currentEvt = evt;
        this.currnetItem = item;
      }else {
        this.addSignatureUser(item, evt);
      }
    },
    handleChange(evt) {
      // if (evt.added) {
      console.log("新增元素:", evt.added.element);
      // }
    },
    pageChange(pageNum) {
      console.log(pageNum, "pageNum");
      // 反显页码的签章
      this.canvas.getObjects().forEach((obj) => this.canvas.remove(obj));
      let currentSign = this.droppedImages.filter(
        (item) => item.pageNum == this.$refs.preview.pageNum
      );
      if (currentSign.length > 0) {
        currentSign.forEach((item) => {
          this.copySignatureUser(item.left, item.top, item);
        });
      }
    },
    handleFileClick(item) {
      let { url } = item;
      if (url == this.url) {
        return;
      }
      this.droppedImages = [];
      this.url = url;
      this.page = 1;
      this.showpreview = true;
    },
    handleFileClick2(item) {
      let { url, pdfId } = item;
      this.droppedImages = [];
      this.droppedImages = this.signEdImages[pdfId] || [];
      console.log(this.droppedImages, "已经盖章的签章数据");
      this.url = url;
      this.page = 1;
      this.showpreview = true;
    },
    getSignList() {
      let uuids = Object.keys(this.signEdImages);
      console.log(uuids, "uuids");
      if (!uuids.length) {
        return [];
      } else {
        return this.flowFileList.filter((item) => uuids.includes(item.pdfId));
      }
    },
    changesignType(val) {},
    submit() {
      console.log(this.signEdImages, "签章数据");
      console.log(this.flowFileList, "pdf文件列表");
      let signEdList = Object.entries(this.signEdImages);
      console.log(signEdList, "signEdList");
      let lastList = [];
      if (signEdList.length) {
        lastList = signEdList.map((item) => {
          let pdfObj = this.flowFileList.find((i) => i.pdfId == item[0]);
          return {
            pdf_file: pdfObj ? pdfObj.url : "",
            pdf_name: pdfObj ? pdfObj.name : "",
            sign_seals: item[1].map((i) => {
              return {
                company_id: i.item.companyObj.id,
                signet_id: i.item.id,
                signet_name: i.item.name,
                signet_link: i.imgUrl,
                type: i.signType, //盖章类型：1-普通盖；2-骑缝盖；
                page: i.pageNum,
                x: Math.round(i.left / 2.8),
                y: Math.round(i.top / 2.8),
                sign_type: i.printType, //打印方式：1-单页；2-双页；
                width:i.item.width,
                height:i.item.height,
              };
            }),
          };
        });
        let params = {
          employee_approval_id: this.dataInfo.id,
          signets: lastList,
        };
        this.submitLoading = true;
        this.$http
          .post("/admin/employeeApproval/signSeal", params)
          .then((res) => {
            if (res.code == 1) {
              this.$emit("signSubmit", res.data);
              this.$message.success("提交成功", "success");
              this.cancel();
            }
            console.log(res, "rrrrr");
          })
          .finally(() =>{
            this.submitLoading = false;
          })
        // this.$emit("signSubmit", lastList);
        console.log(lastList, "lastList");
      } else {
        this.$message.error("请先盖章保存再提交");
      }
    },
  },
  computed: {},
  watch: {
    whDatas: {
      handler() {
        if (!!this.whDatas) {
          this.renderFabric();
          this.canvasEvents();
        }
      },
    },
  },
};
</script>
 

<style scoped lang="scss">
@import "~@/assets/scss/index.scss";
.action-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    display: flex;
    align-items: center;
  }
}
.back-img {
  width: 16px;
  height: 12px;
  background-image: url("~@/assets/img/back.png");
  background-size: contain;
  background-repeat: no-repeat;
  display: inline-block;
  align-items: center;
  vertical-align: middle;
  margin-right: 4px;
}
.img {
  width: 100%;
}
// .build-container {
//   @include position($t: 0, $r: 0, $b: 0, $l: 0);
//   background-color: #f2f5fc;
//   z-index: 5 !important;
//   display: flex;
//   flex-direction: column;
// }
.page-header__wrap {
  height: 50px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #595959;
}
.page-main__wrap {
  padding: 10px;
  background: #fff;
  border-radius: 10px;
  margin-top: 0 !important;
  // flex: 1;
  display: flex;
  flex-direction: column;
  // overflow: auto;
}
.elesign {
  position: relative;
  // margin: 0 auto;
  padding-bottom: 10px;
  flex: 1;
}
.canvas-container {
  // position: absolute;
  // top: 2.625rem;
  // right: 1rem;
}
#ele-canvas {
  pointer-events: all; /* 启用鼠标事件 */
  background-color: transparent; /* 必须有背景才能接收事件 */
}
.has-border {
  // border: 0.0625rem solid #5ea6ef;
}
.ele-control {
  margin-top: 1.25rem;
  text-align: center;
}
.page-main__wrap-main {
  display: flex;
  // position: relative;
  // .pic-box {
  //   width: 48px;
  // }
}
.pic-box {
  // width: 30%;
  // margin-top: 30px;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  display: flex;
  justify-content: center;
  .pic-box-img-box {
    width: 100%;
    max-height:500px;
    border: 1px dashed #e0e0e0;
    overflow-y: auto;
    border-radius: 10px;
    padding: 10px 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  img {
    width: 100px;
    height: 100px;
  }
}
//
.drag-container {
  display: flex;
  gap: 20px;
}
.image-list,
.drop-zone {
  width: 45%;
  min-height: 400px;
  padding: 15px;
  border: 2px dashed #eee;
}
.source-img {
  width: 100px;
  height: 100px;
  margin: 5px;
  cursor: move;
}
.dropped-img {
  width: 150px;
  height: 150px;
  margin: 10px;
}
.bottom-row {
  display: flex;
  justify-content: center;
}
.link-item {
  cursor: pointer;
  color: #5ea6ef;
}
.right-box {
  padding-left: 12px;
  display: flex;
  flex-direction: column;
  > div {
    margin-bottom: 6px;
  }
}
.gaizhang-box {
  position: relative;
}
.top-row {
  padding: 10px;
  display: flex;
  justify-content: end;
  // box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6),
  //   0 2px 4px 0 rgba(232, 237, 250, 0.5);
  z-index: 99;
  background: #fff;
}
.custom-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.radio-item {
  padding: 10px 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}
.radio-item:hover {
  border-color: #c0c4cc;
}
.radio-item.active {
  border-color: #409eff;
  background-color: #ecf5ff;
}
::v-deep .has-header-dialog .el-dialog__header{
  display: block !important;
}
</style>
